<div class="field">
    <span class="field-title">Precio<span class="asterisk">*</span></span>

    <number-input [initialPlaceHolder]="'Ingresar un precio'" [isIncomplete]="isIncomplete || isInvalid"
    [value]="elementSelected" (valueOut)="setElement($event,0)"></number-input>

    <span class="text-is-incomplete" *ngIf="isIncomplete">Completar la siguiente información para continuar.</span>
    <span class="text-is-incomplete" *ngIf="isInvalid">La moneda y el precio no concuerdan.</span>
</div>